<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mr-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Blog
        </v-card-title>
        <page-loader :loading="isFetching" />
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.title"
                outlined
                label="Title"
                :error-messages="errors.title"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <input
                type="file"
                id="imagepath"
                name="imagepath"
                ref="imagepath"
                accept="image/*"
                :error-messages="errors.imagepath"
              />
              <span v-if="errors.imagepath" class="error--text">{{
                errors.imagepath
              }}</span>
            </v-col>
            <v-col sm="12">
              <label for="description" class="dark-label">Description</label>
              <vue-editor
                ref="description"
                v-model="form.description"
                class="form-control"
                :error-messages="errors.description"
              />
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn v-can:edit="'blogs'"
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update Blog
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import { VueEditor } from "vue2-editor";
import axios from "axios";

export default {
  name: "BlogEditPage",
  components: {
    VueEditor,
  },
  data() {
    return {
      form: {
        is_active: false,
      },
      isLoading: false,
      isFetching: false,
    };
  },
  async mounted() {
    this.isFetching = true;
    try {
      await this.getData();
    } finally {
      this.isFetching = false;
    }
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.blogId;
      axios
        .get(`/blogs/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          this.old_json = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        console.log(this.form);
        await axios
          .patch(`/blogs/${this.$route.params.blogId}`, this.form)
          .then(async () => {
            await this.handleFileUpload();
            await this.saveUserTimestamp(this.old_json, this.form);
            this.$router.push("/blogs");
          })
          .catch((error) => {
            this.isLoading = false;
            if (error.response.status != 422) {
              console.error(error);
              this.isUnAuthorised();
            }
          });
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
    async handleFileUpload() {
      console.log("called");
      console.log("uploading");
      let formData = new FormData();
      formData.append("id", this.form.id);
      // imagepath
      if (this.$refs.imagepath?.files[0]) {
        this.imagepath = this.$refs.imagepath.files[0];
        formData.append("imagepath", this.imagepath);
      }
      await axios
        .post("blogs/upload_blog", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .catch(function (error) {
          console.log(error);
          console.log("FAILURE!!");
        });
    },
  },
};
</script>
